import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 5 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      transform: "translate(.042 .019)"
    }, [
      _createElementVNode("circle", {
        cx: "1.996",
        cy: "1.996",
        r: "1.996"
      }),
      _createElementVNode("circle", {
        cx: "1.996",
        cy: "8.981",
        r: "1.996"
      }),
      _createElementVNode("circle", {
        cx: "1.996",
        cy: "15.967",
        r: "1.996"
      })
    ], -1)
  ]))]))
}
export default { render: render }